import React, { Component } from 'react'
import { Switch, BrowserRouter as Router, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import qs from 'query-string';

import FbWrapper from './lib/FirebaseWrapper'

import Home from './views/Home';
import HistoryView from './views/HistoryView';
import ConfirmationView from './views/ConfirmationView';
import PickerView from './views/PickerView';
import LiveTradingView from './views/LiveTradingView';
import SubmitTokenView from './views/LiveTradingView/SubmitTokenView';
import LoginView from './views/Authentication/LoginView';

const Result = ({ match }) =>
  <Route render={
    ({ history, location }) => {
      const query = qs.parse(location.search);
      return (
        <div>
          <HistoryView history={history} account={query.email || "example@example.com"}/>
        </div>
      );
    }
  } />;

const ExampleResult = () =>
  <Route render={
    ({ history, location }) =>
      <div>
        <HistoryView history={history} account={"example@example.com"}/>
      </div>
  } />;

const Picker = ({ match }) =>
  <Route render={
    ({ history }) => (
      <div>
        <PickerView history={history} />
      </div>
    )
  } />;

const LiveTrading = ({ match }) =>
  <Route render={
    ({ history }) => (
      <div>
        <LiveTradingView history={history} />
      </div>
    )
  } />;

const SubmitToken = ({match}) =>
  <Route render={({history}) => <SubmitTokenView history={history} />} />;
const Login = ({match}) =>
  <Route render={({history}) => <LoginView history={history} />} />;


const NormalSubmission = ({ match }) =>
  <Route render={
    ({ history }) => (
      <div>
        <ConfirmationView history={history} submissionKey={match.params.key}/>
      </div>
    )
  } />;

const SubscribedSubmission = ({ match }) =>
  <Route render={
    ({ history }) => (
      <div>
        <ConfirmationView history={history} submissionKey={match.params.key} email={match.params.email}/>
      </div>
    )
  } />;

class App extends Component {
  constructor(props) {
    super(props);

    FbWrapper.onAuthStateChanged(authUser =>
      this.props.onSetAuthUser(authUser ? authUser : null)
    );
  }

  render() {
    let unauthorizedRouter = () =>
      <Router>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route exact path="/example" component={ExampleResult}/>
          <Route component={Login}/>
        </Switch>
      </Router>;

    let authorizedRouter = () =>
      <Router>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route exact path="/example" component={ExampleResult}/>
          <Route exact path="/submission/:key/" component={NormalSubmission}/>
          <Route exact path="/submission/:key/email/:email" component={SubscribedSubmission}/>

          <Route path="/login" component={Login}/>
          <Route path="/result" component={Result}/>
          <Route path="/picker" component={Picker}/>
          <Route path="/livetrading" component={LiveTrading}/>
          <Route path="/submit-token" component={SubmitToken}/>

          <Route component={Home}/>
        </Switch>
      </Router>;

    return !!this.props.authUser
      ? authorizedRouter()
      : unauthorizedRouter();
  }
}

const mapStateToProps = (state) => ({
  authUser: state.sessionState.authUser
});

const mapDispatchToProps = (dispatch) => ({
  onSetAuthUser: (authUser) => dispatch({ type: 'AUTH_USER_SET', authUser })
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js